module.exports = {
	acl(user, defineAbility) {
		let restrictedFields = [];
		const ability = defineAbility((can, cannot) => {
			if (user.role === 'admin') {
				can('manage', 'Invoicereturn');
				can('manage-eta', 'Invoicereturn');
			} else {
				can('manage', 'Invoicereturn', { storeId: { $in: user.storeIds } });
				cannot('delete', 'Invoicereturn');
				cannot('manage-eta', 'Invoicereturn');
				restrictedFields = [
					'etaReturnId',
					'etaSubmissionId',
					'etaReturnStatus',
					'etaDocument',
					'filingClaimId',
					'etaReturnIdHistory',
					'etaUnrecordedSubmissions'
				];
			}
			cannot(['delete', 'update'], 'Invoicereturn', {
				returnStatus: { $in: ['filed', 'filing'] }
			});
		});
		return { ability, restrictedFields };
	}
};
